import React, { useEffect } from 'react';
import QuarterlySidebar from '../../../../molecules/pursuitLeader/components/quarterlySidebar';
import { SidebarWrapper, SidebarTitle } from '../../../../atoms/sidebar/sidebar.styles';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Recoil_Quarter_State,
  Recoil_Summary_Drawer_Toggle,
  SidebarExpandCollapseState,
} from '../../../../../recoil/recoil';
import { isMobile, isTablet } from 'react-device-detect';
import { MotifIcon } from '@ey-xd/motif-react';
import {
  navigationIcClose24px,
  hardwareIcKeyboardArrowRight24px,
  hardwareIcKeyboardArrowLeft24px,
} from '@ey-xd/motif-react/assets/icons';
import { json } from 'react-router-dom';

const SideBar = () => {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const [summaryDrawerToggle, setSummaryDrawerToggle] = useRecoilState(
    Recoil_Summary_Drawer_Toggle,
  );
  const [sidebarExpandState, setSidebarExpandState] = useRecoilState(SidebarExpandCollapseState);

  useEffect(() => {
    if (!!localStorage.getItem('isSidebarExpanded')) {
      setSidebarExpandState(JSON.parse(localStorage.getItem('isSidebarExpanded')));
    }
  }, []);

  const onTitleClick = () => {
    isTablet || isMobile ? setSummaryDrawerToggle(!summaryDrawerToggle) : null;
  };

  // Uncomment below function to enable sidebar expand/collapse functionality
  // const onExpandCollapseClick = () => {
  //   setSidebarExpandState(!sidebarExpandState);
  //   localStorage.setItem('isSidebarExpanded', !sidebarExpandState);
  // };

  const screenWidth = window.innerWidth;

  return (
    <SidebarWrapper>
      <SidebarTitle>
        {quarterInfo != null && (
          <>
            {sidebarExpandState && (
              <>
                {isMobile || isTablet ? (
                  <h3> Summary</h3>
                ) : (
                  <h3>FY {quarterInfo.fiscal_year} Summary</h3>
                )}
              </>
            )}

            {/* Uncomment below condition to enable sidebar expand/collapse functionality */}
            {/* {!isMobile && screenWidth > 1170 ? (
              <MotifIcon
                onClick={onExpandCollapseClick}
                src={
                  sidebarExpandState
                    ? hardwareIcKeyboardArrowRight24px
                    : hardwareIcKeyboardArrowLeft24px
                }
                style={{ color: '#FFFF00' }}
              />
            ) : null} */}
          </>
        )}
        {/*1170 bcz cross button was visible on tablet view that cross icon not needed because sidebar visible on right side */}
        {(isMobile || isTablet) && screenWidth < 1170 ? (
          <MotifIcon
            onClick={onTitleClick}
            src={navigationIcClose24px}
            style={{ color: '#FFFFFF' }}
          />
        ) : null}
      </SidebarTitle>
      <QuarterlySidebar />
    </SidebarWrapper>
  );
};
export default SideBar;
